/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Tabs_AlertsInputs */

const he_account_tabs_alerts = /** @type {(inputs: Account_Tabs_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות`)
};

const en_account_tabs_alerts = /** @type {(inputs: Account_Tabs_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerts`)
};

/**
* | output |
* | --- |
* | "Alerts" |
*
* @param {Account_Tabs_AlertsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_tabs_alerts = /** @type {((inputs?: Account_Tabs_AlertsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Tabs_AlertsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_tabs_alerts(inputs)
	return en_account_tabs_alerts(inputs)
});